module.exports = __webpack_public_path__ + "img/fd9a1.671af743.svg";